import i18n from '@/plugins/i18n';

export const elastiCacheOverviewHeader = () => [
  {
    key: 'service_eca_host_swap_usage',
    tileName: `${i18n.global.t('aws.swapUsage')} (${i18n.global.t('aws.mb')})`,
    name: `${i18n.global.t('aws.swapUsage')} (${i18n.global.t('aws.mb')})`,
    valueType: 'avgofAvg',
    convertTo: 'MB',
    value: 'avg',
    tooltip: `${i18n.global.t('aws.swapUsageTooltip')}`,
  },
  {
    key: 'service_eca_host_cluster_count',
    tileName: i18n.global.t('aws.clusterCount'),
    name: i18n.global.t('aws.clusterCount'),
    valueType: 'sumofsum',
    value: 'sum',
    tooltip: `${i18n.global.t('aws.clusterCountTooltip')}`,
  },
  {
    key: 'service_eca_host_node_count',
    tileName: i18n.global.t('aws.nodeCount'),
    name: i18n.global.t('aws.nodeCount'),
    valueType: 'sumofsum',
    value: 'sum',
    tooltip: `${i18n.global.t('aws.nodeCountTooltip')}`,
  },
  {
    key: 'service_eca_host_memory_available',
    tileName: i18n.global.t('aws.memoryAvailable'),
    name: i18n.global.t('aws.memoryAvailable'),
    valueType: 'avgofavg',
    convertTo: 'MB',
    value: 'avg',
    tooltip: `${i18n.global.t('aws.memoryAvailableTooltip')}`,
  },
];

export const OVERVIEW_PAGE = 'overview';
export const SUBSCRIPTION_PAGE = 'subscriptionId';
export const MAX_SLICE = 5;
export const MIN_SLICE = 0;
export const SUBSCRIPTION_MAX_SLICE = 1;
export const SUBTYPE = 'ELASTICACHE';
export const CLOUD_TYPE = 'CAPABILITY_CLOUD';
export const PARENT = 'parent';
export const CHILD = 'child';
